import React from 'react';
import PropTypes from 'prop-types';

export default function RatingStars({ value }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
      <img
        src={
          value >= 1 ? '/images/star_filled.svg' : '/images/star_unfilled.svg'
        }
        alt={value}
      />
      <img
        src={
          value >= 2 ? '/images/star_filled.svg' : '/images/star_unfilled.svg'
        }
        alt={value}
      />
      <img
        src={
          value >= 3 ? '/images/star_filled.svg' : '/images/star_unfilled.svg'
        }
        alt={value}
      />
      <img
        src={
          value >= 4 ? '/images/star_filled.svg' : '/images/star_unfilled.svg'
        }
        alt={value}
      />
      <img
        src={
          value === 5 ? '/images/star_filled.svg' : '/images/star_unfilled.svg'
        }
        alt={value}
      />
    </div>
  );
}

RatingStars.propTypes = {
  value: PropTypes.number.isRequired,
};
